import { useState } from "react";
import useFetchWithMsal from "../hooks/useFetchWithMsal";
import { protectedResources } from "../authConfig";
import { isTestEnv } from "../globals";
import translations from '../translations/addCustomerFormTranslation';


const useAddCustomer = (customers, setCustomers, setMockDropdownData) => {
    const [open, setOpen] = useState(false);
    const [customerName, setCustomerName] = useState('');
    const [customerDes, setCustomerDes] = useState('');
    const [street, setStreet] = useState('');
    const [city, setCity] = useState('');
    const [country, setCountry] = useState('');
    const [apNumber, setApNumber] = useState('');
    const [floor, setFloor] = useState('');
    const [phone2, setPhone2] = useState('');
    const [nsFlag, setNsFlag] = useState('');
    const [phonenum, setPhonenum] = useState('');
    const [status, setStatus] = useState('');
    const [customerType, setCustomerType] = useState('');
    const [isOrderingCustomer, setIsOrderingCustomer] = useState(false);
    const [isReceivingCustomer, setIsReceivingCustomer] = useState(false);
    const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
    const [isLoading, setIsLoading] = useState(false);

    const { execute } = useFetchWithMsal({
        scopes: protectedResources.apiScopes.scopes.read,
    });
    /** Getting customer information by customer name */
    const fetchCustomerDetails = async () => {
        if (customerName) {
            setIsLoading(true);
            try {
                const response = await execute(
                    "GET",
                    `${process.env.REACT_APP_BACKEND_BASE_URL}/api/customers/getCUSTDESTSOfCustomer?custname=${encodeURIComponent(customerName)}`
                );
                console.log(39, response);

                if (response === 'No Customer Found') {
                    setSnackbar({ open: true, message: translations.loadingError, severity: 'error' });
                }
                setCustomerDes(response.CUSTDES);
                setStreet(response.ADDRESS);
                setCity(response.STATE);
                setCountry(response.COUNTRYNAME);
                setApNumber(response.NEO_APARTMENT);
                setFloor(response.NEO_FLOOR);
                setPhone2(response.NEO_PHONE2);
                setPhonenum(response.PHONE);
                setStatus(response.STATDES);
                setNsFlag(response.NSFLAG);
            } catch (error) {
                isTestEnv && console.error(translations.loadingError, error);
                setSnackbar({ open: true, message: translations.loadingError, severity: 'error' });
            } finally {
                setIsLoading(false);
            }
        }
    };
    /** Reset states */
    const handleCancel = () => {
        setCustomerName('');
        setCustomerDes('');
        setCustomerType('');
        setCity('');
        setStreet('');
        setCountry('');
        setApNumber('');
        setFloor('');
        setPhone2('');
        setNsFlag('');
        setPhonenum('');
        setStatus('');
        setIsOrderingCustomer(false);
        setIsReceivingCustomer(false);
        setOpen(false);
    };
    /** Sending the form to the server */
    const handleSubmit = async () => {
        const customerData = {
            custname: customerName,
            custdes: customerDes,
            customerType,
            orderingCustomer: isOrderingCustomer,
            recivingCustomer: isReceivingCustomer,
            address: {
                city,
                street,
                country,
                apNumber,
                floor,
                phonenum,
                phone2
            },
            status,
            nsFlag
        };

        //Check if there is a customer with the same customer name in the customer list
        const isDuplicate = customers.some((customer) => customer.custname === customerData.custname);

        if (isDuplicate) {
            setSnackbar({ open: true, message: translations.duplicateCustomer, severity: 'warning' });
            return; // If there is a customer with the same name, stop the operation.
        }

        try {
            setSnackbar({ open: false });
            const response = await execute(
                "POST",
                `${process.env.REACT_APP_BACKEND_BASE_URL}/api/customers/addCustomer`,
                customerData
            );
            setCustomers((prevDara) => [...prevDara, response]);
            if (response.recivingCustomer && response.status === 'פעיל')
                setMockDropdownData((prev) => ({ ...prev, receiveCustomer: [...prev['receiveCustomer'], response] }));
            if (response.orderingCustomer && response.status === 'פעיל')
                setMockDropdownData((prev) => ({ ...prev, ordererCustomer: [...prev['ordererCustomer'], response] }));
            setSnackbar({ open: true, message: translations.addSuccess, severity: 'success' });
        } catch (error) {
            isTestEnv && console.error(translations.serverError, error);
            setSnackbar({ open: true, message: translations.serverError, severity: 'error' });
        }

        handleCancel();
    };


    const isFormValid = customerName && customerDes && customerType && (isOrderingCustomer || isReceivingCustomer);

    return {
        snackbar, setSnackbar,
        open, setOpen,
        customerName, setCustomerName,
        customerDes, setCustomerDes,
        customerType, setCustomerType,
        isOrderingCustomer, setIsOrderingCustomer,
        isReceivingCustomer, setIsReceivingCustomer,
        handleCancel,
        translations,
        fetchCustomerDetails,
        isLoading,
        handleSubmit,
        isFormValid
    }
};

export default useAddCustomer;